export default __webpack_public_path__ + "static/char-s-12-en-ddd979c0afadf7c071ce8c7d9bfcafbe.png";